import script from "./counterDown.vue?vue&type=script&setup=true&lang=js"
export * from "./counterDown.vue?vue&type=script&setup=true&lang=js"

import "./counterDown.vue?vue&type=style&index=0&id=2d70e02e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d70e02e"]])

export default __exports__